import { StandardLayout } from "common/layouts/StandardLayout";
import MultiRouteEmbed from "features/embed/MultiRouteEmbed";
import { TripRouteEmbed } from "features/embed/TripRouteEmbed";
import _ from "lodash";
import queryString from "query-string";
import React from "react";
import EmbedConfigurator from "./EmbedConfigurator";

const embedTypes = {
  event: MultiRouteEmbed,
  trip: TripRouteEmbed,
  route: TripRouteEmbed,
};

export class EmbedConfiguratorApp extends React.PureComponent {
  render() {
    const params = queryString.parse(this.props.location.search);
    const EmbedType = embedTypes[params.type] || MultiRouteEmbed;
    const embedProps = _.pick(params, Object.keys(EmbedType.propTypes));
    return (
      <StandardLayout>
        <EmbedConfigurator {...embedProps} />
      </StandardLayout>
    );
  }
}
